module.exports = __webpack_public_path__ + "assets/media/3.d7955554.wav";